import { AccountApiCredentialsRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/api_credentials/')({
  component: AccountApiCredentialsRoute,
});
